export enum TenantTableAction {
  SWITCH = "switch"
}
